// CacheKey 642ae227c4f565f64d88d1df18dcad05
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-CEDAR_COMMUNITY": {
    simple_form: {
      labels: {
        encounter: {
          risk_score_1_on_discharge: "Home Health Agency"
        }
      }
    }
  }
}

